import { Grid } from "@mui/material";
import { useMediaQuery } from "@mui/system";
import { settings } from "app";
import { doctoralRequests } from "api/doctoralApi";
import BackButtonToolbar from "features/BackButtonToolbar";
import {
  Labeled,
  ReferenceField,
  Show,
  SimpleShowLayout,
  TextField,
} from "react-admin";
import { SectionTitle } from "features/SectionTitle";

const ShowDoctoralDisciplines = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));

  return (
    <Show
      title="Детайли за докторантска дисциплина"
      actions={<BackButtonToolbar />}
    >
      <SimpleShowLayout>
        <SectionTitle
          title="Информация"
          textAlign="center"
          sx={{ marginTop: "2rem" }}
        />

        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid item xs={12} md={6}>
            <Labeled label="Име на български език">
              <TextField source="nameBg" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Име на английски език">
              <TextField source="nameEn" />
            </Labeled>
          </Grid>
          <Grid item xs={12} md={6}>
            <Labeled label="Главна дисциплина">
              <ReferenceField
                source="parentId"
                reference={doctoralRequests.getDoctoralDisciplinesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
        </Grid>
      </SimpleShowLayout>
    </Show>
  );
};

export default ShowDoctoralDisciplines;
